import ko from 'knockout';

export default class ThreadReply {
    constructor() {
        this.id = ko.observable();
        this.body = ko.observable();
        this.subject = ko.observable();
        this.url = ko.observable();
        this.communities = ko.observableArray();
        this.agrees = ko.observable();
        this.thanks = ko.observable();
        this.userAvatar = ko.observable();

        this.bodyLabel = ko.pureComputed(() => {
            const words = this.body().split(/\s/);
            // truncate more than 35 words
            if (words.length >= 35) {
                const truncated = words.splice(0, 35).join(' ');
                return `${truncated}\u2026`;
            }
            return this.body();
        });

        this.isTruncated = ko.pureComputed(
            () => this.body().split(/\s/).length > 35,
        );
    }

    setData(data) {
        this.id(data.id);
        this.body(data.body);
        this.subject(data.subject);
        this.url(data.url);
        this.communities(data.tags);
        this.agrees(data.agrees);
        this.thanks(data.thanks);
        this.userAvatar(data.userAvatar);
    }
}
